import React from 'react';
import PropTypes from 'prop-types';

import Config from 'configuration';

import logo from 'assets/img/FL_logo_anniversary.png';

export default function Hero({ currentArea, description }) {
  const areaImage = (currentArea || { image: null }).image;
  const backgroundImage = areaImage && `url("${Config.imageUrl}headers/${areaImage}.png")`;

  return (
    <div className="banner profile__banner">
      <div
        className="profile__banner-backdrop"
        style={{ backgroundImage }}
      />
      <div className="profile__hero">
        <h1>
          <img
            className="img-responsive u-space-below"
            alt="Fallen London - Home of the Echo Bazaar"
            src={logo}
            style={{ filter: 'drop-shadow(0 0 8px black)' }}
          />
        </h1>
        <h2 className="heading heading--1 profile__heading">
          {!!description && description}
        </h2>
      </div>
    </div>
  );
}

Hero.propTypes = {
  description: PropTypes.string,
  currentArea: PropTypes.shape({
    image: PropTypes.string,
  }),
};

Hero.defaultProps = {
  description: undefined,
  currentArea: {
    image: null,
  },
};